import React, {Component}   from 'react';
import {
  Container,
  Divider,
  Header,
  Image,
}                           from 'semantic-ui-react';
import {withRouter}         from 'react-router';
import PropTypes            from 'prop-types';
import _                    from 'lodash';
import Slider               from 'react-slick';
import {isMobile}           from 'react-device-detect';
// Atoms
import ImageFit             from '../../atoms/imageFit';

// Global
import getMessage           from '../../global/getMessage';
// import bbCode              from '../../global/buildLang';
// Controller
import MainGaelleController from './MainGaelleController';

// Style
import                      '../MainStyle/MainTwo.scss';
import                      './MainGaelle.scss';
// Images
import Gaelle               from '../../images/gaelleLogo.png';
import gaelleGeneral        from '../../images/aCES_8613.jpg';
import kid                  from '../../images/kid.jpg';
import cour                 from '../../images/cour.jpg';
import concert              from '../../images/concert.jpg';
// import cour2                from '../../images/cour2.jpg';

/** Disabled workshop */
// import workshop            from '../../images/workshop.jpg';

const propTypes = {
  content     : PropTypes.arrayOf(PropTypes.object),
  currentLang : PropTypes.string,
  history     : PropTypes.shape({push: PropTypes.func}).isRequired,
  lang        : PropTypes.shape({menu: PropTypes.object}),
};

const defaultProps = {
  content     : null,
  currentLang : 'fr',
  lang        : {},
};

class MainGaelle extends Component {

  render() {
    const {
      currentLang,
      lang,
    } = this.props;

    const contentMsg = this.props.content || getMessage('section.home.content', lang);
    const content = [];

    _.forOwn(contentMsg, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    /** Disabled workshop */
    // const contentWorkshop = getMessage('section.home.workshop', lang);
    // const contentWrk = [];
    //
    // _.forOwn(contentWorkshop, (value, key) => {
    //   contentWrk.push(
    //     <p key={key}>
    //       {value}
    //     </p>
    //   );
    // });

    const settings = {
      autoplay       : true,
      autoplaySpeed  : 5000,
      dots           : true,
      fade           : true,
      infinite       : true,
      speed          : 1000,
      slidesToShow   : 1,
      slidesToScroll : 1,
    };

    return (
      <Container className='sgr-mainHome-grid-two-sub'>
        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>
            <Image
              alt=''
              size={isMobile ? 'medium' : 'medium'}
              src={Gaelle}
            />
          </Header.Content>
          <Header.Subheader style={{fontSize: currentLang === 'fr' ? '1.1em' : '2.25rem'}}>
            {getMessage('section.home.header.subTitle')}
          </Header.Subheader>
        </Header>

        <Divider hidden />
        <Divider hidden />

        <Slider {...settings}>
          <div className='img-carousel'>
            <ImageFit src={gaelleGeneral} />
            {/* <h3>{'11111'}</h3> */}
          </div>
          <div className='img-carousel'>
            <ImageFit src={cour} />
            <h3>{'Leçon de chant'}</h3>
          </div>
          <div className='img-carousel'>
            <ImageFit src={kid} />
            <h3>{'Eveil Musical'}</h3>
          </div>
          <div className='img-carousel'>
            <ImageFit src={concert} />
            <h3>{'Animation'}</h3>
          </div>
        </Slider>

        {content}

        {/* Disabled workshop */}
        {/* {contentWrk[0]}*/}
        {/* <a href='/price'>*/}
        {/*  <img*/}
        {/*    src={workshop}*/}
        {/*    style={{maxWidth: '100%'}}*/}
        {/*  />*/}
        {/* </a>*/}
        {/* {contentWrk[1]}*/}
      </Container>
    );
  }

}

MainGaelle.propTypes = propTypes;
MainGaelle.defaultProps = defaultProps;

export const MainGaelleTest = MainGaelle;

export default MainGaelleController(withRouter(MainGaelle));



// WEBPACK FOOTER //
// ./src/organisms/MainGaelle/MainGaelle.js